<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    created () {
      const STORE_KEY = 'cym_store';
      //在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem(STORE_KEY) ) {
        this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem(STORE_KEY))))
      }

      //在页面刷新时将vuex里的信息保存到sessionStorage里
      window.addEventListener("unload",()=>{
        sessionStorage.setItem(STORE_KEY,JSON.stringify(this.$store.state))
      })
    }
  }

</script>
<style lang="scss">
  @import "assets/scss/base";
</style>
